<template>
  <v-app>
    <v-content>
      <router-view/>
    </v-content>
  </v-app>
</template>

<script>

export default {
  name: 'App',

  components: {
  },

  data: () => ({
    //
  })
}
</script>

<style lang="stylus">
@font-face {
  font-family: "Montserrat";
  src: local("Montserrat"),   url(./assets/fonts/Montserrat-Regular.ttf) format("truetype");}
@font-face {
  font-family: "Montserrat-SemiBold";
  src: local("Montserrat-SemiBold"),   url(./assets/fonts/Montserrat-SemiBold.ttf) format("truetype");}

</style>
